<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#005f32" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-app-bar color="#3d673A">
      <v-layout row justify-space-between align-center px-3>
        <!-- Logo Section (Left) -->
        <v-flex class="d-sm-none d-flex justify-center">
          <v-img
            max-width="100px"
            max-height="100px"
            src="@/assets/Images/wtilogo.png"
          ></v-img>
        </v-flex>

        <v-flex xs4 sm2 md2 lg2 class="hidden-xs-only">
          <v-img
            max-width="100px"
            max-height="100px"
            src="@/assets/Images/wtilogo.png"
          ></v-img>
        </v-flex>

        <!-- Menu Icon Section (Right) -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon style="color: white">mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="navigateTo('faq')">
              <v-list-item-title
                ><span class="listmenu">FAQS</span></v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="navigateTo('Visitors')">
              <v-list-item-title
                ><span class="listmenu"
                  >REGISTRATION FOR VISITORS</span
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="navigateTo('Exhibitors')">
              <v-list-item-title
                ><span class="listmenu"
                  >REGISTRATION FOR EXHIBITORS</span
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="navigateTo('sponsor')">
              <v-list-item-title
                ><span class="listmenu"
                  >BECOME A SPONSOR</span
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item @click="scrollToDonation">
              <v-list-item-title
                ><span class="listmenu">DONATE TO WTI</span></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-layout>
    </v-app-bar>
    <v-layout wrap justify-center pa-1>
      <v-flex xs12 sm4 lg4>
        <v-img src="@/assets/Images/GWF/headerlogoog.webp">
          <template v-slot:placeholder>
            <ImageLoader />
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 class="hidden-sm-and-up">
        <v-img src="@/assets/Images/GWF/bannerog.webp" height="70vh" cover>
          <template v-slot:placeholder>
            <ImageLoader />
          </template>
          <v-container
            fill-height
            class="d-flex flex-column text-center"
            style="height: 100%; justify-content: flex-start; align-items: center; position: relative;"
          >
            <!-- <span class="popregular help-text">Global Wildlife Fair</span> -->
            <v-btn
              class="know-more-btn"
              color="#ecb338"
              style="color: white; margin: 10px; position: absolute; bottom: 10px; right: 10px;"
              @click="openDonationDialog"
              >Know More</v-btn
            >
          </v-container>
        </v-img>
      </v-flex>
      <v-flex xs12 class="hidden-xs-only">
        <v-img src="@/assets/Images/GWF/bannerog.webp" height="78vh" cover>
          <template v-slot:placeholder>
            <ImageLoader />
          </template>
          <v-container
            fill-height
            class="d-flex flex-column text-center"
            style="height: 100%; justify-content: flex-start; align-items: center; position: relative;"
          >
            <!-- <span class="popregular help-text">Global Wildlife Fair</span> -->
            <v-btn
              class="know-more-btn"
              color="#ecb338"
              style="color: white; margin: 10px; position: absolute; bottom: 10px; right: 10px;"
              @click="openDonationDialog"
              >Know More</v-btn
            >
          </v-container>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showSnackBar: false,
      msg: "",
      ServerError: false,
      timeout: 3000,
      appLoading: false,
    };
  },
  methods: {
    openDonationDialog() {
      window.open("https://www.globalwildlifefair.com/", "_blank");
    },
    navigateTo(page) {
      if (page === "faq") {
        window.open("https://www.globalwildlifefair.com/faqs", "_blank");
      } else if (page === "Visitors") {
        window.open("https://www.globalwildlifefair.com/visitors", "_blank");
      } else if (page === "Exhibitors") {
        window.open(
          "https://www.globalwildlifefair.com/index.php/exhibitors",
          "_blank"
        );
      } else if (page === "sponsor") {
        window.open(
          "https://www.globalwildlifefair.com/index.php/sponsor-us",
          "_blank"
        );
      } else if (page === "donateWTI") {
        window.open(
          "https://www.globalwildlifefair.com/index.php/exhibitors",
          "_blank"
        );
      }
    },
    scrollToDonation() {
      const donationSection = document.getElementById("donationGwfSection");
      if (donationSection) {
        donationSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style scoped>
.listmenu {
  font-family: poppinsregular;
  text-transform: uppercase;
}
.LBL >>> label {
  font-family: poppinsregular !important;
  font-size: 12px !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: grey;
  border-radius: 5px;
}

.v-radio >>> label {
  font-size: 20px;
  font-family: poppinsregular;
  color: black;
}
.center >>> input {
  text-align: center;
  font-family: poppinsregular;
  font-size: 32px;
}
.center2 >>> label {
  text-align: center;
  font-family: poppinsregular;
}
.center4 {
  text-align: center !important;
  font-family: poppinsregular !important;
}
.boldR >>> label {
  font-family: poppinsbold;
}
.animate {
  position: relative;
  animation: mymove 0.25s;
}
.animate2 {
  position: relative;
  animation: mymove2 0.25s;
}
#div2 {
  animation-timing-function: linear;
}
@keyframes mymove2 {
  from {
    left: -200px;
  }
  to {
    left: 0px;
  }
}

@keyframes mymove {
  from {
    right: -500px;
  }
  to {
    right: 0px;
  }
}
#div1 {
  animation-timing-function: linear;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear; /* Safari */
  animation: spin 2s linear;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.v-checkbox >>> label {
  font-family: poppinsregular;
}
.help-text {
  color: white;
  font-size: 50px;
}

@media (max-width: 600px) {
  .help-text {
    font-size: 30px;
  }
}
.anyotheramt {
  font-size: 16px;
  text-transform: none;
}
@media (max-width: 600px) {
  .anyotheramt {
    font-size: 13px;
  }
}
@media (max-width: 600px) {
  .know-more-btn {
    font-size: 12px;
    padding: 5px 10px;
    height: auto;
    min-width: auto;
  }
}

@media (min-width: 1024px) {
  .know-more-btn {
    font-size: 18px;
    padding: 10px 20px;
    height: auto;
    min-width: auto;
  }
}
</style>
